import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchChartsData, FetchChartsDataParams } from '../../api/chartsData';

export const fetchChartsDataAction = createAsyncThunk(
  'chartsData/fetchChartsDataAction',
  (params: FetchChartsDataParams) => fetchChartsData(params)
);
